import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ReferralUser, User, WorkCompUser } from "@app/core/interfaces/user.interface";
import { environment } from "@env/environment";
import { Observable, of } from "rxjs";
import { AccountTypes } from "../enums/accountTypes.enum";

@Injectable({
    providedIn: 'root'
})
export class UserDetailsService {
  constructor(
    private http: HttpClient
    ) { }

  getUserDetails$(userId: string, accountType: AccountTypes): Observable<User|ReferralUser|WorkCompUser> {
    if (accountType === AccountTypes.ADMIN) {
      return this.http.get<User>(`${environment.apiUrl}/admin/${userId}/settings-details`);
    } else if (accountType === AccountTypes.REFERRAL_PARTNER) {
      return this.http.get<ReferralUser>(`${environment.apiUrl}/users/referral/${userId}/settings-details`);
    } else {
      return this.http.get<WorkCompUser>(`${environment.apiUrl}/users/work-comp/${userId}/settings-details`);
    }
  }
}
